import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import RouterConstants from '@app/constants/router';
import colors from '@app/constants/colors';

const Menu = ({ pathname }) => (
  <MenuContainer>
    <MenuLink to={RouterConstants.ACCOUNT} actived={pathname === '/account'}>
      <FormattedMessage id="header.myAccount" />
    </MenuLink>
    <MenuLink to={RouterConstants.ACCOUNT_SUBSCRIPTION} actived={pathname === '/account/subscription'}>
      <FormattedMessage id="header.mySubscription" />
    </MenuLink>
    <MenuLink to={RouterConstants.ACCOUNT_DEVICES} actived={pathname === '/account/devices'}>
      <FormattedMessage id="header.myDevices" />
    </MenuLink>
  </MenuContainer>
);

Menu.propTypes = {
  pathname: PropTypes.string.isRequired,
};

const mapStateToProps = ({ router: { location: { pathname } } }) => ({
  pathname,
});

export default withRouter(connect(mapStateToProps)(Menu));

const MenuContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 740px;
  width: 100%;
  height: 100%;

  @media (max-width: 1149px) {
    max-width: 640px;
    justify-content: space-around;
  }
  @media (max-width: 979px) {
    display: none;
  }
`;

const MenuLink = styled(Link)`
  color: ${colors.HEAR};
  font-weight: ${({ actived }) => (actived ? 'bold' : 'normal')};
  font-size: 29px;
  margin: 0 10px;
  display: flex;
  align-items: center;

  @media (max-width: 1149px) {
    font-size: 23px;
  }
`;
